import { Company } from './TypeProps';

export const diskManufacturerSort = (list: Company[]): Company[] => {
  return [...list].sort((a, b) => a.Company?.toLowerCase().localeCompare(b.Company?.toLowerCase()));
};
